export default __webpack_public_path__ + "static/1-14a767824b2e3fb8132b37ad7f2c8887.png";